export type AdminPulseVisibility = 'hidden' | 'level_1' | 'all';

export interface AdminFilterablePulse {
  category?: string | null;
  visibility?: string | null;
  adminPulseLevel?: string | null;
}

export function filterPulsesForAdminVisibility<T extends AdminFilterablePulse>(
  pulses: T[] | undefined | null,
  isAdmin: boolean,
  visibility: AdminPulseVisibility,
): T[] {
  if (!pulses) return [];
  return pulses.filter((p) => {
    const isAdminCategory = p.category === 'admin';
    const isAdminOnly = p.visibility === 'admin_only';

    if (!isAdmin) {
      return !isAdminCategory && !isAdminOnly;
    }
    if (visibility === 'all') return true;
    if (visibility === 'hidden') {
      return !isAdminCategory && !isAdminOnly;
    }
    // 'level_1': show only level_1 admin-category pulses; admin_only-locked
    // regular pulses remain hidden (matches the "see what regular users see
    // plus a strict subset of admin audit pulses" intent).
    if (isAdminOnly) return false;
    if (isAdminCategory) return p.adminPulseLevel === 'level_1';
    return true;
  });
}
